import type { ReactNode } from "react";

export function CardLabel({ children }: { children: ReactNode }) {
  return <div className="card-label">{children}</div>;
}

export function DetailsCard({ label, children }: { label?: ReactNode; children: ReactNode }) {
  return (
    <div className="details-card">
      {label != null && <CardLabel>{label}</CardLabel>}
      {children}
    </div>
  );
}
